import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  warrantyMap,
  wastageMap,
  destructionMap,
  createTable,
} from "./tableMaps";
import { withModels } from "../../../models/queries";
import styles from "./BrowseRecords.module.css";
import CSVexport from "../CSVexport";

const tables = {
  dest: destructionMap,
  waste: wastageMap,
  warr: warrantyMap,
};

const tableToPath = {
  dest: "cert",
  waste: "wastage",
  warr: "limited_warranty",
};

function EditableCell(props) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (props.initialValue === "Pending") return;
    setChecked(props.initialValue);
    if (props.tableType !== "waste")
      props.setParentApproved(props.initialValue);
    else if (props.dbKey === "finalApproved")
      props.setParentApproved(props.initialValue);
  }, [props.initialValue, props.setParentApproved]);

  useEffect(() => {
    if (checked && props.initialValue === "Pending") {
      if (props.dbKey === "finalApproved") {
        props.models.approveWastageFinal(props.recordId);
        return;
      }
      switch (props.tableType) {
        case "waste":
          props.models.approveWastageRecord(
            props.recordId,
            props.dbKey.includes("Denied")
          );
          break;
        case "dest":
          props.models.approveDestructionRecord(props.recordId);
          break;
        case "warr":
          props.models.approveWarrantyRecord(
            props.recordId,
            props.dbKey.includes("Denied")
          );
          break;
        default:
          return;
      }
    }
  }, [
    checked,
    props.recordId,
    props.initialValue,
    props.tableType,
    props.models,
  ]);

  //cannot uncheck
  return (
    <input
      type="checkbox"
      checked={checked || false}
      disabled={props.disabled}
      onChange={() => {
        props.openModal({
          message: `Are you sure you want to ${
            props.dbKey.includes("Denied") ? "deny" : "approve"
          } this claim?`,
          onConfirm: () => {
            setChecked(true);
            props.setParentApproved(true);
            props.closeModal();
          },
          onCancel: props.closeModal,
        });
      }}
      className={props.className}
      style={props.style}
    />
  );
}

const ConnectedCell = withModels(EditableCell);

function Record({ row, recordId, tableType, openModal, closeModal }) {
  const history = useHistory();
  const [approved, setApproved] = useState(false);
  const [destructionFormId, setDestructionFormId] = useState(false);
  if (tableType === "waste" && !destructionFormId) {
    let cell = row.find((v) => v.key === "destructionFormId");
    return setDestructionFormId(cell.value);
  }
  return (
    <tr>
      {row
        .filter((v) => !(v.key === "destructionFormId"))
        .map((cell, i) => {
          return (
            <td key={`row-${recordId}-${i}`}>
              {cell.editable ? (
                <ConnectedCell
                  tableType={tableType}
                  openModal={openModal}
                  closeModal={closeModal}
                  initialValue={cell.value}
                  recordId={recordId}
                  dbKey={cell.key}
                  disabled={cell.key.includes("Denied") && approved}
                  setParentApproved={setApproved}
                />
              ) : cell.format ? (
                cell.format(cell.value, destructionFormId)
              ) : (
                <span
                  className={styles.linkSpan}
                  onClick={() =>
                    history.push(`/admin/${tableToPath[tableType]}/${recordId}`)
                  }
                >
                  {cell.value.toString()}{" "}
                </span>
              )}
            </td>
          );
        })}
    </tr>
  );
}

export default function Table({ tableType, records, openModal, closeModal }) {
  const table = createTable(tables[tableType], records);
  return (
    <>
      <CSVexport
        records={records}
        tableType={tableType}
        cmp={<button className={styles.csvButton}> Export CSV </button>}
      />
      <table className={styles.table}>
        <thead>
          <tr>
            {table.headers
              .filter((v) => !(v === "Destruction Record"))
              .map((v) => {
                return <th key={`record-header-${v}`}> {v} </th>;
              })}
          </tr>
        </thead>
        <tbody>
          {table.records.map((v, i) => (
            <Record
              key={`record-${v._id}`}
              row={v.cells}
              recordId={v._id}
              tableType={tableType}
              openModal={openModal}
              closeModal={closeModal}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}
